module.exports = __webpack_public_path__ + "img/products-1@2x.3b69a48.jpg";